import { useLocation } from "react-router-dom";
import ListenButton from "@/components/ListenButton";

// Routes with substantial editorial text content where "Listen to" + Translate
// are genuinely useful. The Manifesto page has its own inline tools bar, so
// this floating widget skips it.
const LISTEN_ROUTES = [
  "/about",
  "/climate-change",
  "/nature-museum",
  "/faq",
  "/weather",
  "/weather-almanac",
  "/terms",
  "/privacy",
];

/**
 * FloatingListenBar — small bottom-left dock on text-heavy pages that lets
 * readers listen to the page (browser TTS) and switch the reading language.
 * Reads from `<main>` since our AppShell has a single main container that
 * wraps every route.
 */
export default function FloatingListenBar() {
  const { pathname } = useLocation();
  const show = LISTEN_ROUTES.some((r) => pathname === r || pathname.startsWith(r + "/"));
  if (!show) return null;

  return (
    <div
      className="fixed bottom-24 md:bottom-6 left-4 z-40"
      data-testid="floating-listen-bar"
      data-listen-skip
    >
      <div className="flex items-center gap-2 rounded-full border border-black/10 bg-[color:var(--np-bg,#F5EBDC)]/95 backdrop-blur px-2.5 py-2 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.35)]">
        <ListenButton rootSelector="main" label="Listen to page" />
      </div>
    </div>
  );
}
